export const random = () => Math.random().toString(36).substr(2, 5)
